export default __webpack_public_path__ + "static/media/sponsor-altium.5daf3089.png";